import { useCallback, useState } from 'react'
import TwinTrans from '../../../../../TwinTrans'
import { SetCompleteDataTy } from '../../../types'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import { flushSync } from 'react-dom'
import { faXmark, faPencil } from '@fortawesome/pro-light-svg-icons'
import TwinIcon from '../../../../../TwinIcon'
import TwinTagSelector from '../../../../../TwinTagSelector'
import { InputTableLeftColumnChange } from '../../types'

interface ITHeaderOrderTagsProps extends ITHeaderOrderTagsLogicProps {
    className?: string
    readOnly?: boolean
    dictTags: TwinDictionary
    selectedTags: string[]
}

export const ITHeaderOrderTags: React.FC<ITHeaderOrderTagsProps> = ({ className, selectedTags, dictTags, readOnly = false, ...logic}) => {
    const { addTag, removeTag, editOrderTags, setEditOrderTags } = useITHeaderOrderTagsLogic({...logic})
    return (
        <div className={(className || '')}>
            <div className='flex items-center'>
                <span className='mr-10'>
                    <TwinTrans transKey='tags'>Etiquetas</TwinTrans>
                </span>
                {!readOnly ? <TwinIcon className='cursor-pointer' icon={editOrderTags ? faXmark : faPencil} onClick={() => setEditOrderTags((old) => !old)} /> : null }
            </div>
            <TwinTagSelector dictTags={dictTags} readOnly={!editOrderTags} selectedTags={selectedTags || []} {...{ addTag, removeTag }} />
        </div>
    )
}

interface ITHeaderOrderTagsLogicProps {
    setCompleteData: SetCompleteDataTy
    headerData: TwinDictionary
    onChange: InputTableLeftColumnChange
}

const useITHeaderOrderTagsLogic = ({ headerData, setCompleteData, onChange }: ITHeaderOrderTagsLogicProps) => {
    const [editOrderTags, setEditOrderTags] = useState<boolean>(false)

    const saveTagsChanges = useCallback(async (tags: string[]) => {
        onChange(headerData?.id, 'tagsForParse', tags?.join(';') || '')
    }, [headerData?.id, onChange])

    const addTag = useCallback(async (TagId: number) => {
        await flushSync(async () => {
            let tags: string[] = []
            await setCompleteData((old) => {
                if (!old) {
                    return null
                }
                const copyOld = JSON.parse(JSON.stringify(old))
                if (!copyOld?.header?.tags) {
                    copyOld.header.tags = []
                }
                copyOld.header.tags.push(parseInt(String(TagId)))
                tags = copyOld.header.tags
                return { ...copyOld }
            })
            await saveTagsChanges(tags)

        })
    }, [setCompleteData, saveTagsChanges])

    const removeTag = useCallback(async (posArr: number) => {
        let tags: string[] = []
        await flushSync(async () => {
            await setCompleteData((old) => {
                if (!old) {
                    return null
                }
                const copyOld = JSON.parse(JSON.stringify(old))
                copyOld.header.tags.splice(posArr, 1)
                tags = copyOld.header.tags
                return { ...copyOld }
            })
            await saveTagsChanges(tags)
        })
    }, [setCompleteData, saveTagsChanges])

    return { editOrderTags, setEditOrderTags, addTag, removeTag, saveTagsChanges }
}